import AppLayout from '@components/layouts/appLayout';

import { StoryFooter } from '../components/layout/StoryFooter';
import { StoryHeader } from '../components/layout/StoryHeader';
import { StoryWrapper } from '../components/layout/StoryWrapper';
import NavigationOverlay from '../components/NavigationOverlay';
import VideoPlayer from '../components/video/VideoPlayer';
import { useVideoPlayerContext } from '../contexts/VideoPlayerContext';
import { StoryPageDisplay, StoryPageType } from '../enums';
import { Renderer, Tester } from '../types';

export const renderer: Renderer = ({ story, storyPage }) => {
    // upper-case expected for component
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { playVideo, pauseVideo } = useVideoPlayerContext();

    return (
        <AppLayout
            hasFixedFooter
            footerHasPointerEvents={false}
            header={
                <StoryHeader withExit story={story} storyPage={storyPage} />
            }
            body={
                <StoryWrapper>
                    <NavigationOverlay
                        onPlay={playVideo}
                        onPause={pauseVideo}
                    />
                    <VideoPlayer storyPage={storyPage} />
                </StoryWrapper>
            }
            footer={
                <StoryFooter
                    withCtas
                    storyPage={storyPage}
                    withNavigationButtons={false}
                    withVideoPlayerButtons={true}
                />
            }
        />
    );
};

export const tester: Tester = (display, storyPage) => {
    return {
        condition:
            display === StoryPageDisplay.Default &&
            storyPage.type === StoryPageType.Video &&
            !!storyPage.ctas,
        priority: 7,
    };
};

const rendererWithTester = { renderer, tester };

export default rendererWithTester;
